<template lang="pug">
.conteudo(v-if="processo")
    .cabecalho-pagina
        title-component(:label="processo.nomeImovel")
        subtitle-component(:label="processo.codigoImovel")

    .botoes-container
        button-component.download-recebidos(
          label="Documentos Recebidos"
          icon="mdi-download"
          @click.native="abrirModalDocumentosRegularidadeRecebidos"
          class="hover-btn-download"
        )

        button-component.download-analise(
          label="Relatório de Análise Técnica"
          icon="mdi-download"
          @click.native="downloadTodosDocumentosAnalise"
          class="hover-btn-download"
        )

        button-component.download-prada(
          label="Download do Prada"
          icon="mdi-download"
          @click.native="downloadDocumentoPrada"
          class="hover-btn-download"
        )
    .divisor
    div
        .linha(style='marginTop: 0px')
            .coluna
                breadcrumb-component(:list='breadcrumb')
    .steps
        step-by-step-component(
            v-if='newSteps.length > 0',
            v-model='currentStep'
            :list='newSteps',
            @step:step-change='getStep($event)')
    div(v-if='currentStep')
        EtapaIARA(
            v-if='currentStep.codigo === EtapaEnum.IARA.id',
            ref='etapaIARA',
            :tipos-documentos='tiposDocumentos'
        )
        EtapaMRA(
            v-if='currentStep.codigo === EtapaEnum.MRA.id',
            ref='etapaMRA',
            :tipos-documentos='tiposDocumentos',
            @click="handleClick"
        )
        EtapaPRADA(
            v-if='currentStep.codigo === EtapaEnum.PRADA.id',
            ref='etapaPRADA',
            :tipos-documentos='tiposDocumentos',
           )
        EtapaRESUMO(
            v-if='currentStep.codigo === EtapaEnum.RESUMO.id',
            ref='etapaRESUMO',
            :tipos-documentos='tiposDocumentos',
            @toEtapa='getEtapaResumo($event)'
            @resultado='getResultadoAnalise'
            :processo="processo"
        )
    .footer
        .buttons
            .left
                button-component(
                    label='Voltar',
                    icon='mdi-keyboard-backspace',
                    background-color='#ddd',
                    color='#666',
                    @click.native='voltar()'
                )
            .right
                button-component(
                    v-if='!isGerenteOperacional && !isAguardandoValidacao'
                    :label='isEtapaResumo ? "Finalizar Análise" : "Salvar Etapa"',
                    :icon='isEtapaResumo ? "mdi-check" : "mdi-content-save"',
                    @click.native='salvar(false)'
                    :disabled='finalizarDesabilitado'
                    :style='{ cursor: finalizarDesabilitado ? "not-allowed" : "pointer" }'
                ).button-save
                button-component(
                    v-if='!isEtapaResumo'
                    :label='"Próximo"',
                    :icon='"mdi-arrow-right"',
                    @click.native='salvar(true)'
                )
                button-component(
                    v-if='isGerenteOperacional && isAguardandoValidacao && isEtapaResumo'
                    label='Validar Análise',
                    icon='mdi-check',
                    @click.native='validacaoGO()'
                )

    modal-component(
        v-if='exibirModalValidarFinalizar.status',
        title='Atenção!',
        @close='exibirModalValidarFinalizar.status = false'
    )
        ModalValidarFinalizar(@validarFinalizar='confirmar($event)', :text='exibirModalValidarFinalizar.text')

    modal-component(
        v-if='exibirModalDocumentosRegularidade',
        title='Documentos Regularidade Recebidos',
        @close='exibirModalDocumentosRegularidade = false'
    )
        ModalDocumentosRegularidade(:infoProcesso='processo')
</template>

<script>
import {buscarPorId, buscarStatusEtapas, downloadPrada} from '@/services/processo.service';
import {listarTiposDocumentos} from '@/services/tipo-documento.service';

import EtapaIARA from '@/views/analise/EtapaIARA.vue';
import EtapaMRA from '@/views/analise/EtapaMRA.vue';
import EtapaPRADA from '@/views/analise/EtapaPRADA.vue';
import EtapaRESUMO from '@/views/analise/EtapaResumo.vue';
import ModalConfirmacaoEtapas from '@/views/analise/components/ModalConfirmacaoEtapas.vue';
import ModalValidarFinalizar from '@/views/analise/components/ModalValidarFinalizar.vue';
import ModalDocumentosRegularidade from '@/views/analise/components/ModalDocumentosRegularidade.vue';

import {EtapaEnum} from '@/enums/processo.enum.js';
import {getAnaliseSteps} from '@/utils/step.utils';
import {analiseTecnica, validacaoAnaliseGO} from '@/utils/breadcrumb.utils.js';
import {downloadRelatorioAnaliseTecnica, getAnalisesByIdProcessoAnaliseEquipe,} from '@/services/analiseService.service';
import {Perfil} from '@/utils/constants.utils.js';
import {CondicaoEnum} from '@/enums/processo.enum';

export default {
    components: {
        EtapaIARA,
        EtapaMRA,
        EtapaPRADA,
        EtapaRESUMO,
        ModalConfirmacaoEtapas,
        ModalValidarFinalizar,
        ModalDocumentosRegularidade,
    },

    data() {
        return {
            processo: null,
            tiposDocumentos: [],
            exibirModalDocumentosRegularidade: false,
            EtapaEnum,
            storedDefaultSteps: [],
            newSteps: [],
            analiseTecnica,
            validacaoAnaliseGO,

            selectedStep: null,
            isStepbyStep: false,
            currentStep: null,
            etapasStatus: {},

            exibirModalValidarFinalizar: {
                status: false,
                text: '',
            },
            resultadoAnalise: null,
            statusDocumentos: {
                possuiParecerAtivo: false,
                possuiRelatorio: false,
                possuiNotificacao: false,
            }
        };
    },

    computed: {
        isEtapaResumo() {
            return this.currentStep?.codigo === EtapaEnum.RESUMO.id;
        },
        isGerenteOperacional() {
            return this.$eu().perfil === Perfil.GERENTE_OPERACIONAL;
        },
        isAguardandoValidacao() {
            return this.processo.condicao === CondicaoEnum.AGUARDANDO_VALIDACAO_ANALISE.id;
        },
        breadcrumb() {
            return this.isGerenteOperacional ? this.validacaoAnaliseGO : this.analiseTecnica;
        },
        finalizarDesabilitado() {
            return this.isEtapaResumo && this.resultadoAnalise === 'ANDAMENTO';
        },
        possuiDocumentosAnalise() {
            // Verifica se ao menos um dos documentos está disponível
            return (
                this.statusDocumentos.possuiParecerAtivo ||
                this.statusDocumentos.possuiRelatorio ||
                this.statusDocumentos.possuiNotificacao
            );
        }
    },

    async mounted() {
        try {
            const [processo, tiposDocumentos, etapasStatus] = await Promise.all([
                buscarPorId(this.$route.params.id),
                listarTiposDocumentos(),
                buscarStatusEtapas(this.$route.params.id),
            ]);
            this.processo = processo;
            this.tiposDocumentos = tiposDocumentos;

            this.etapasStatus.jumpEtapaIARA = false;
            this.etapasStatus.jumpEtapaMRA = false;
            this.etapasStatus.jumpEtapaPRADA = false;
            this.etapasStatus.jumpResumo = false;

            if ( this.roundToTwo(this.processo.areaTotalCompensar) === 0 && this.roundToTwo(this.processo.areaTotalRecompor) === 0 && this.processo.existeFormularioPrada) {
                this.etapasStatus.etapaIARA = true;
                this.etapasStatus.etapaMRA = false;
                this.etapasStatus.etapaPRADA = false;
                this.etapasStatus.etapaResumo = true;
                this.etapasStatus.jumpEtapaIARA = false;
                this.etapasStatus.jumpEtapaMRA = true;
                this.etapasStatus.jumpEtapaPRADA = true;
                this.etapasStatus.jumpResumo = false;
            }else {
                this.etapasStatus.etapaIARA = true;
                this.etapasStatus.etapaMRA = false;
                this.etapasStatus.etapaPRADA = false;
                this.etapasStatus.etapaResumo = false;
                this.etapasStatus.jumpEtapaIARA = false;
                this.etapasStatus.jumpEtapaMRA = false;
                this.etapasStatus.jumpEtapaPRADA = false;
                this.etapasStatus.jumpResumo = false;
            }

            this.storedDefaultSteps = await getAnaliseSteps(this.etapasStatus);

            this.currentStep = this.storedDefaultSteps[0];
            this.currentStep.isEditing = true;
            this.selectedStep = { codigo: 'IARA', label: 'IARA' };
            this.mudarStep();

            this.$route.params.codigoImovelCriptografado = processo.codigoImovelCriptografado;
            this.$route.params.aderiuPra = processo.aderiuPra;
            this.$route.params.condicao = processo.condicao;
        } catch {
            this.$toast({
                showClose: true,
                message: 'Erro ao carregar informações do processo!',
                type: 'error',
            });
        }
    },

    methods: {
        async voltar() {
            this.selectedStep = this.currentStep;

            switch (this.selectedStep?.codigo) {
                case EtapaEnum.IARA.id:
                    this.$router.push({ name: 'analise-proposta' });
                    break;
                case EtapaEnum.MRA.id:
                    this.setProximoStep({
                        label: 'IARA',
                        codigo: 'IARA',
                    });
                    break;
                case EtapaEnum.PRADA.id:
                    this.setProximoStep({
                        label: 'MRA',
                        codigo: 'MRA',
                    });
                    break;
                case EtapaEnum.RESUMO.id:
                    if ( this.roundToTwo(this.processo.areaTotalCompensar) === 0 && this.roundToTwo(this.processo.areaTotalRecompor) === 0 && this.processo.existeFormularioPrada) {
                        this.setProximoStep({
                            label: 'IARA',
                            codigo: 'IARA',
                        });
                    } else {
                        this.setProximoStep({
                            label: 'PRADA',
                            codigo: 'PRADA',
                        });
                    }
                    break;
                default:
                    break;
            }
        },

        async proximo() {
            this.selectedStep = this.currentStep;

            switch (this.selectedStep?.codigo) {
                case EtapaEnum.IARA.id:
                    if ( this.roundToTwo(this.processo.areaTotalCompensar) === 0 && this.roundToTwo(this.processo.areaTotalRecompor) === 0 && this.processo.existeFormularioPrada) {
                        this.setProximoStep({
                            label: 'RESUMO',
                            codigo: 'RESUMO',
                        });
                    } else {
                        this.setProximoStep({
                            label: 'MRA',
                            codigo: 'MRA',
                        });
                    }
                    break;
                case EtapaEnum.MRA.id:
                    this.setProximoStep({
                        label: 'PRADA',
                        codigo: 'PRADA',
                    });
                    break;
                case EtapaEnum.PRADA.id:
                    this.setProximoStep({
                        label: 'RESUMO',
                        codigo: 'RESUMO',
                    });
                    break;
                case EtapaEnum.RESUMO.id:
                    break;
                default:
                    break;
            }
        },

        async salvar(proximaEtapa) {
            switch (this.currentStep.codigo) {
                case EtapaEnum.IARA.id:
                    this.processo = await this.$refs.etapaIARA.salvar();
                    this.etapasStatus.etapaMRA = true;
                    break;
                case EtapaEnum.MRA.id:
                    this.processo = await this.$refs.etapaMRA.salvar();
                    this.processo.etapaAtual = EtapaEnum.PRADA.id;
                    break;
                case EtapaEnum.PRADA.id:
                    this.processo = await this.$refs.etapaPRADA.salvar();
                    this.processo.etapaAtual = EtapaEnum.RESUMO.id;
                    break;
                case EtapaEnum.RESUMO.id:
                    this.processo.etapaAtual = EtapaEnum.RESUMO.id;
                    await this.finalizacaoTenico();
                    break;
            }

            const etapasStatus = await buscarStatusEtapas(this.$route.params.id);
            this.etapasStatus.jumpEtapaIARA = false;
            this.etapasStatus.jumpEtapaMRA = false;
            this.etapasStatus.jumpEtapaPRADA = false;
            this.etapasStatus.jumpResumo = false;

            if ( this.roundToTwo(this.processo.areaTotalCompensar) === 0 && this.roundToTwo(this.processo.areaTotalRecompor) === 0  && this.processo.existeFormularioPrada) {
                this.etapasStatus.etapaIARA = true;
                this.etapasStatus.etapaMRA = false;
                this.etapasStatus.etapaPRADA = false;
                this.etapasStatus.etapaResumo = true;
                this.etapasStatus.jumpEtapaIARA = false;
                this.etapasStatus.jumpEtapaMRA = true;
                this.etapasStatus.jumpEtapaPRADA = true;
                this.etapasStatus.jumpResumo = false;
            }
            this.storedDefaultSteps = await getAnaliseSteps(etapasStatus);

            if (proximaEtapa) {
                await this.proximo();
            }
        },

        async downloadDocumentoPrada() {
            try {
                const response = await downloadPrada(this.processo.id);

                if (!response || !response.data || response.data.size === 0) {
                    this.$toast({
                        showClose: true,
                        message: 'Nenhum dado recebido para download',
                        type: 'warning',
                        duration: 5000,
                        position: 'right'
                    });
                    return;
                }

                var file = window.URL.createObjectURL(new Blob([response.data]));
                var docUrl = document.createElement('a');
                docUrl.href = file;
                docUrl.setAttribute('download', 'prada.pdf');
                document.body.appendChild(docUrl);
                docUrl.click();
            } catch (error) {
                // Tratamento de erro com blob do tipo JSON retornado pelo backend
                if (error?.response?.data instanceof Blob && error.response.data.type === 'application/json') {
                  const blob = error.response.data;
                  try {
                      const text = await blob.text();
                      const json = JSON.parse(text);
                      this.$toast({
                          showClose: true,
                          message: json.message || 'Erro ao baixar documento Prada',
                          type: 'error',
                          duration: 5000,
                          position: 'right'
                      });
                  } catch (e) {
                      this.$toast({
                          showClose: true,
                          message: 'Erro ao interpretar resposta do servidor',
                          type: 'error',
                          duration: 5000,
                          position: 'right'
                      });
                  }
                } else {
                  // Erros genéricos
                  this.$toast({
                      showClose: true,
                      message: 'Erro ao baixar documento Prada, arquivo não encontrado',
                      type: 'error',
                      duration: 5000,
                      position: 'right'
                  });
                }
            }
        },
        async abrirModalDocumentosRegularidadeRecebidos() {
            this.exibirModalDocumentosRegularidade = true;
        },
        async downloadTodosDocumentosAnalise() {
            if (!this.processo.idAnaliseEquipe) {
                this.$toast({
                    showClose: true,
                    message: 'Não foi possível buscar os dados do relatório',
                    type: 'warning',
                    duration: 5000,
                    position: 'right'
                });
                return;
            }

            try {
                const response = await getAnalisesByIdProcessoAnaliseEquipe(this.processo.idAnaliseEquipe);
                if (!response || !Array.isArray(response) || response.length === 0) {
                    this.$toast({
                        showClose: true,
                        message: 'Documentos de Análise de Equipe não encontrados, verifique Análise Dinamizada',
                        type: 'warning',
                        duration: 5000,
                        position: 'right'
                    });
                    return;
                }

                // Ordena de forma descrescente para pegar o registro de analise mais recente
                response.sort((a, b) => b.id - a.id);
                const resultados = response[0].resultadosParecerLiderAnalise;

                const numeroRelatorio = resultados && resultados[0] && resultados[0].validacaoAnalise
                    ? resultados[0].validacaoAnalise.numeroRelatorio : null;

                if (!numeroRelatorio) {
                    this.$toast({
                        showClose: true,
                        message: 'Número do relatório não encontrado',
                        type: 'warning',
                        duration: 5000,
                        position: 'right'
                    });
                    return;
                }

                const relatorioResponse = await downloadRelatorioAnaliseTecnica(numeroRelatorio).catch((reason) => {
                    console.error('Erro ao baixar relatório de análise técnica:', reason);
                    this.$toast({
                        showClose: true,
                        message: 'Erro ao baixar relatório de análise técnica',
                        type: 'error',
                        duration: 5000,
                        position: 'right'
                    });
                    return null;
                });

                if (relatorioResponse && relatorioResponse.data) {
                    const baixarArquivo = (response, defaultFilename) => {
                        if (!response || !response.data || response.data.size === 0 || response.headers['content-type'] !== 'application/pdf') {
                            this.$toast({
                                showClose: true,
                                message: 'Relatório de análise técnica não encontrado',
                                type: 'warning',
                                duration: 5000,
                                position: 'right'
                            });
                            return;
                        }

                        // 1. Get the header
                        const disposition = response.headers['content-disposition'];

                        // 2. Extract the filename
                        let filename = defaultFilename;
                        if (disposition && disposition.indexOf('filename=') !== -1) {
                            const matches = disposition.match(/filename="?([^"]+)"?/);
                            if (matches && matches[1]) {
                                filename = decodeURIComponent(matches[1]);
                            }
                        }

                        // 3. Create download
                        const blob = new Blob([response.data], { type: response.headers['content-type'] });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    };

                    baixarArquivo(relatorioResponse, numeroRelatorio + '.pdf');
                }
            } catch (error) {
                console.error('Erro geral ao baixar relatório:', error);
                this.$toast({
                    showClose: true,
                    message: 'Erro ao baixar relatório de análise técnica',
                    type: 'error',
                    duration: 5000,
                    position: 'right'
                });
            }
        },

        getStep(newStep) {
            this.selectedStep = newStep;
            this.isStepbyStep = true;
        },

        setProximoStep(newStep) {
            this.isStepbyStep = false;
            this.selectedStep = newStep;
            this.next();
        },

        mudarStep() {
            this.currentStep = this.selectedStep;
            this.newSteps = this.storedDefaultSteps;

            this.newSteps.forEach((s) => {
                s.isEditing = s.codigo === this.currentStep.codigo;
            });
        },

        next() {
            if (this.selectedStep?.codigo) {
                this.mudarStep();
            }
        },

        getEtapaResumo(event) {
            this.processo.etapaAtual = event;
        },

        async confirmar(resposta) {
            if (!resposta) this.exibirModalValidarFinalizar.status = false;
            else if (resposta && this.isGerenteOperacional) {
                if (
                    this.$refs.etapaRESUMO.validacaoGO?.aprovado === 'APROVADO' ||
                    (this.$refs.etapaRESUMO.validacaoGO?.aprovado === 'REPROVADO' &&
                        this.$refs.etapaRESUMO.validacaoGO?.justificativa)
                ) {
                    this.processo = await this.$refs.etapaRESUMO.validarGO();
                } else {
                    this.$toast({
                        showClose: true,
                        message: 'Por favor, preencha corretamente as informações sobre a validação da análise.',
                        type: 'warning',
                    });
                }
            } else if (resposta && !this.isGerenteOperacional) {
                const response = await this.$refs.etapaRESUMO.finalizarAvaliacaoTecnica();
                if (response) {
                    this.processo = response;
                } else {
                    this.exibirModalValidarFinalizar.status = false;
                }
            }
        },

        async finalizacaoTenico() {
            this.exibirModalValidarFinalizar.text = 'Deseja realmente finalizar a análise técnica?';
            this.exibirModalValidarFinalizar.status = true;
        },

        async validacaoGO() {
            this.exibirModalValidarFinalizar.text = 'Deseja realmente validar a análise técnica?';
            this.exibirModalValidarFinalizar.status = true;
        },

        getResultadoAnalise(resultado) {
            this.resultadoAnalise = resultado;
        },

        roundToTwo(value) {
            return Math.round(value * 100) / 100;
        },

        handleClick(event) {
            if (!this.etapasStatus.etapaMRA) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.cabecalho-pagina {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.divisor {
    border-bottom: 1px solid var(--primary-dark-smoke);
    margin: 20px 0px;
}

.steps {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.footer {
    width: 100%;
    margin-top: 50px;
}

.buttons {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .right {
        display: flex;
    }
}

.button-save {
    padding: 0px 15px;
    margin-right: 18px;
}

.button-component.download-prada {
    padding: 15px;
    font-weight: bold;
}

.botoes-container {
    display: flex;
    justify-content: flex-start;
    /* Ou 'center', dependendo da necessidade */
    gap: 16px;
    /* Espaçamento entre os botões */
}

.hover-btn-download:hover {
  background-color: #4caf50 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.disabled-component {
    pointer-events: none; /* Desabilita cliques e interações */
    opacity: 0.6; /* Opcional: reduz a opacidade para indicar que está desabilitado */
}

</style>
